<template>
  <section class="burger-wrapper">
    <rp-sprite :class="['burger-icon', isShowByDefault() ? 'default-show' : '']" name="menu"/>
  </section>
</template>

<script>
  import Sprite from 'raypro_ui/src/components/ui/Sprite'
  export default {
    props: {cross: Boolean},
    components: {'rp-sprite': Sprite},
    methods: {
      isShowByDefault() {
        // Show by default on all dashboard pages
        return this.$route.path.startsWith('/dashboard')
      }
    }
  }
  
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import '../stylesheets/helpers/mixins'
  
  .burger-icon
    width: 25px
    height: 25px
    fill: $color-panel-bg
    margin: 0px 15px
    cursor: pointer
    @include media($media-medium)
      display: none

    &.default-show
      display: block

</style>



// WEBPACK FOOTER //
// src/components/Burger.vue